import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";
import { Loading } from "components/panels";
import { CompanyCanReceivePeppol } from "InvoiceV2/components/CompanyCanReceivePeppol";
import { CompanyApi } from "queries/Company";
import React from "react";

interface Props {
  companyId: number;
}

export const CanReceivePeppol = (props: Props) => {
  const api = CompanyApi.CanReceivePeppol.useQuery(props.companyId, {});

  if (api.data == null || api.isLoading) {
    return <Loading />
  }

  if (api.isError || api.data?.hasErrors) {
    return <SomethingUnexpectedHappenedMessageBox />
  }

  return <CompanyCanReceivePeppol compliance={api.data.data} />
}